import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const TicketIcon = (props: IconProps) => {
    return (
		<Icon {...props}>
			<svg viewBox="0 0 48 48" >
				<g fill="currentColor">
                    <path d="M17.1 30.9c.3.3.6.4 1.1.4s.8-.1 1.1-.4.4-.6.4-1.1-.1-.8-.4-1.1-.6-.4-1.1-.4-.8.1-1.1.4-.4.6-.4 1.1.1.8.4 1.1m5.8-5.8c.3.3.6.4 1.1.4s.8-.1 1.1-.4.4-.6.4-1.1-.1-.8-.4-1.1-.6-.4-1.1-.4-.8.1-1.1.4-.4.6-.4 1.1.1.8.4 1.1m5.9-5.9c.3.3.6.4 1.1.4s.8-.1 1.1-.4.4-.6.4-1.1-.1-.8-.4-1.1-.6-.4-1.1-.4-.8.1-1.1.4-.4.6-.4 1.1.1.8.4 1.1m-4.1 27.9L.9 23.3q-.9-.9-.9-2.1t.9-2.1l5.4-5.4c1.1.7 2.2 1 3.5.8 1.3-.1 2.4-.6 3.3-1.6s1.5-2 1.6-3.3-.2-2.4-.9-3.5L19.1.9Q20 0 21.2 0t2.1.9l23.8 23.8q.9.9.9 2.1t-.9 2.1l-5.4 5.4c-1-.7-2.2-1-3.5-.9s-2.4.7-3.3 1.6-1.5 2-1.6 3.3.2 2.4.8 3.5l-5.4 5.4q-.9.9-2.1.9t-2.1-.9Zm2.1-2.1 3.8-3.8c-.3-1.5-.2-3 .1-4.5s1.1-2.8 2.2-3.9 2.4-1.8 3.9-2.2 3-.4 4.5-.1l3.8-3.8L21.2 3l-3.8 3.8q.45 2.25 0 4.5c-.45 2.25-1.1 2.7-2.2 3.8s-2.4 1.8-3.8 2.2-2.9.4-4.5 0l-3.8 3.8 23.8 23.8Z"/>
				</g>
			</svg>
		</Icon>
    )
}

export default TicketIcon;